<self-filer-section [header]="'ON_BOARDING_WARNING.STEP1'" [description]="'COMPANY.SELF_FILER_CODE_DESC'">
  <card-default *ngIf="!isHasFilerCode" [description]="'ON_BOARDING.FILER_CODE_REQUEST.STEP1'" [sticky]="true">
    <div *ngIf="isSent" class="attention mb-2">
      {{ "ON_BOARDING.FILER_CODE_EMAIL_SENT" | translate }}
    </div>
    <button
      card-footer
      type="button"
      class="btn btn-primary"
      [routerLink]="['/on-boarding', 'filer-code-request']"
      [queryParams]="{ returnUrl: currentUrl }"
    >
      {{ "ON_BOARDING.GET_SELF_FILER_REQUEST_TEMPLATE" | translate }}
    </button>
  </card-default>
  <self-filer-set-filer-code-form
    *ngIf="!isHasFilerCode"
    [companyId]="companyId"
    [mainPort]="filerCodeInfo.homePort"
    (update)="afterUpdate()"
  ></self-filer-set-filer-code-form>
  <self-filer-code-add-additional-ports
    *ngIf="isHasFilerCode"
    [filerCode]="filerCodeInfo.filerCode"
    [mainPort]="filerCodeInfo.homePort"
    [companyId]="companyId"
    [additionalPorts]="additionalPorts"
    (update)="afterUpdate()"
  ></self-filer-code-add-additional-ports>

  <ng-container [formGroup]="fg" *ngIf="!!filerCodeInfo?.filerCode">
    <div control-wrapper class="custom-control custom-checkbox mt-2 text-right">
      <input
        type="checkbox"
        class="custom-control-input"
        formControlName="abiTransmitterUpdateApproved"
        id="abi-transmitter-update-approved"
        (change)="updateAbiTransmitter($event.target.value)"
      />
      <label class="custom-control-label" for="abi-transmitter-update-approved">
        {{ "FORM_LABEL.ABI_TRANSMITTER_UPDATED" | translate }}
      </label>
    </div>
  </ng-container>
</self-filer-section>
